import { C } from "@/lib/format";

const X0 = -5.3, Y0 = 51.3, K = 0.69; // equirectangular, cos(46.5°) — same projection as the mobile app
const W = (9.8 - X0) * K, H = Y0 - 41.2;
const px = (lon) => (lon - X0) * K;
const py = (lat) => Y0 - lat;

export const metricColor = (m) => (m === "masters" ? C.success : m === "agents" ? C.silver : C.brand);

export function FranceMap({ depts, metric, selected, onSelect }) {
  const max = Math.max(1, ...depts.map((d) => d[metric]));
  const color = metricColor(metric);
  const metro = depts.filter((d) => d.lat !== null);
  const dom = depts.filter((d) => d.lat === null);
  return (
    <div data-testid="france-map" className="flex flex-col gap-3">
      <div className="w-full overflow-hidden rounded-[20px] border border-[#333333] bg-[#1E1E1E]" style={{ aspectRatio: `${W} / ${H}` }}>
        <svg viewBox={`-0.3 -0.3 ${W + 0.6} ${H + 0.6}`} className="h-full w-full" role="img" aria-label="Carte de France par département">
          {metro.map((d) => {
            const v = d[metric];
            const r = v > 0 ? 0.16 + 0.42 * Math.sqrt(v / max) : 0.1;
            const sel = selected === d.code;
            const x = px(d.lon), y = py(d.lat);
            return (
              <g key={d.code} data-testid={`map-dept-${d.code}`} onClick={() => onSelect(d.code)} className="cursor-pointer" role="button" tabIndex={0}
                aria-label={`${d.code} ${d.name} : ${v}`} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect(d.code)}>
                <title>{`${d.code} · ${d.name} — ${v}`}</title>
                <circle cx={x} cy={y} r={0.38} fill="transparent" />
                <circle cx={x} cy={y} r={r} fill={v > 0 ? color : C.borderStrong} fillOpacity={v > 0 ? 0.35 + 0.6 * (v / max) : 0.6}
                  stroke={sel ? "#FFFFFF" : "none"} strokeWidth={sel ? 0.06 : 0} className="transition-all duration-300" />
                {v > 0 && r > 0.28 ? (
                  <text x={x} y={y + 0.1} fontSize={0.28} fontWeight={700} fill="#121212" textAnchor="middle" pointerEvents="none">{v}</text>
                ) : null}
              </g>
            );
          })}
        </svg>
      </div>
      <div className="no-scrollbar flex gap-2 overflow-x-auto">
        {dom.map((d) => (
          <button key={d.code} type="button" data-testid={`map-dom-${d.code}`} onClick={() => onSelect(d.code)}
            className={`focus-ring h-9 shrink-0 rounded-full border bg-[#1E1E1E] px-3 text-xs ${selected === d.code ? "border-white" : "border-[#333333]"}`}
            style={{ color: d[metric] > 0 ? color : C.muted }}>
            {d.name} · {d[metric]}
          </button>
        ))}
      </div>
    </div>
  );
}
